module.exports = "/virtual-football-league/img/amblems/right/logos/Fake_Watford.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/Fake_Watford.png
// module id = 2197
// module chunks = 4